import { render, staticRenderFns } from "./ExamCard.vue?vue&type=template&id=674e578e&scoped=true"
import script from "./ExamCard.vue?vue&type=script&lang=js"
export * from "./ExamCard.vue?vue&type=script&lang=js"
import style0 from "@/assets/stylesheets/components/home/fastcards/ExamCard.scss?vue&type=style&index=0&id=674e578e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e578e",
  null
  
)

export default component.exports